import React from 'react';
import PropTypes from 'prop-types';

const SelectResearch = ({ items, name, updateField, disabled }) => (
	<label htmlFor={name} className="label">
		<div className="select is-fullwidth">
			<select
				disabled={disabled}
				name={name}
				id={name}
				onChange={updateField}
				className="is-fullwidth has-background-white-bis"
			>
				{items}
			</select>
		</div>
	</label>
);

SelectResearch.propTypes = {
	items: PropTypes.instanceOf(Array).isRequired,
	name: PropTypes.instanceOf(String).isRequired,
	updateField: PropTypes.instanceOf(Function).isRequired,
	disabled: PropTypes.instanceOf(Boolean),
};

SelectResearch.defaultProps = {
	disabled: null,
};

export default SelectResearch;
